































import Vue from 'vue'
import { Component, Prop, Emit } from 'vue-property-decorator'
import { casePriorityKeys, casePriorityValues, casePriority } from '@/modules/Case/helpers/case'
import { updateCasePriority } from '@/modules/Case/gql/case.gql'
import { showErrors, showNotification } from '@/utils/snack'
import { SnackType } from '@/interfaces/snack'

@Component({})
export default class CasePrioritySwitcher extends Vue {
  @Prop({ type: Number }) readonly value!: number
  @Prop({ type: Number }) readonly caseId!: number

  casePriority = casePriority
  casePriorityOptions = casePriorityValues

  showList = false

  caseStatusDialog = {
    show: false,
    status: 'INQUIRY'
  }

  dotClass (item: string) {
    switch (item) {
      case 'High':
        return 'dot-red'
      case 'Medium':
        return 'dot-blue'
      case 'Low':
        return 'dot-gray'
      default:
    }
  }

  async onSelect (index: number) {
    const { caseId } = this
    this.showList = false
    try {
      const result = await this.$apollo.mutate({
        mutation: updateCasePriority,
        variables: {
          caseId,
          priority: casePriorityKeys[index - 1]
            ? Number(casePriorityKeys[index - 1])
            : null
        }
      })

      const res = result.data.updateCasePriority
      if (res) {
        showNotification({
          msg: 'Switch case priority successfully',
          type: SnackType.Success
        })
        this.onSuccess()
      }
    } catch (error) {
      showErrors(error.graphQLErrors)
    }
  }

  @Emit('success')
  onSuccess () {
    // do nothing
  }
}
